import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import Main from './containers/Main';
import store from './store';
import * as serviceWorker from './serviceWorker';
import { ErrorBoundary } from './components/errors/ErrorBoundary';
import './index.scss';
import './assets/stylesheets/style.scss';

// Create app component
const app = document.getElementById('root');
render(
  <ErrorBoundary>
      <Provider store={store}>
        <Main />
      </Provider>
  </ErrorBoundary>
  , app
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
